import store from '@/store'
import panelManager from '@/core/helpers/panelManager'
import eventBus from '@/core/plugins/event-bus'
import i18n from '@/core/plugins/vue-i18n'
import { DOCK_ICONS } from '@/components/dock/dockIcons'

function navigateFileRelation(rel, router) {
    if (rel.type === 'MODULE_NOTE') {
        panelManager.openPanel('noteApp', { itemId: rel.id })
    } else if (rel.type === 'MODULE_VEHICLE_WORK_ORDER') {
        router.push('/module/vehicle-work-order/save/' + rel.id)
    } else if (rel.type === 'FILE_MANAGER_FOLDER') {
        panelManager.openPanel('fileManagerPanel')
    }
}

export default {
    platformType: 'admin',

    getContextId() {
        return null
    },

    getContextParams() {
        return {}
    },

    getMembers() {
        return store.state.user?.table?.data || []
    },

    async loadMembers() {
        await store.dispatch('user/get', { filterData: { 'roles[]': 1, page_limit: 100 } })
    },

    mapMember(o) {
        return {
            id: o.id,
            name: o.full_name || ''
        }
    },

    getContextWatchPath() {
        return null
    },

    getMembersWatchPath() {
        return '$store.state.user.table.data'
    },

    getModuleCodes() {
        const data = store.state.module?.table?.data || []
        return data.flatMap(kind => (kind.modules || []).map(m => m.code))
    },

    async loadModules() {
        await store.dispatch('module/get')
    },

    getModulesData() {
        const data = store.state.module?.table?.data || []
        return data.flatMap(kind => kind.modules || [])
    },

    getModulesStorePath() {
        return (s) => s.module?.table?.data
    },

    getNavigationMap() {
        return {
            USERS:          () => null,
            COMPANIES:      () => null,
            FILES:                      (item, router) => {
                const relations = item.meta?.relations
                if (!relations || !relations.length) {
                    panelManager.openPanel('fileManagerPanel', { previewFileId: item.id })
                    return
                }
                if (relations.length === 1) {
                    navigateFileRelation(relations[0], router)
                } else {
                    const t = i18n.global.t
                    const truncate = (s, max) => s && s.length > max ? s.slice(0, max) + '…' : s
                    const buttons = [
                        ...relations.map(r => ({ label: truncate(r.label, 30), type: 'default', value: r })),
                        { label: t('common.cancel'), type: 'cancel' }
                    ]
                    eventBus.$emit('showConfirmDialog', {
                        title: item.title,
                        message: t('common.spotlight.fileMultipleRelations'),
                        buttons,
                        onConfirm: (rel) => navigateFileRelation(rel, router),
                    })
                }
            },
            FILE_FOLDERS:               (item) => panelManager.openPanel('fileManagerPanel', { folderId: item.id }),
            MODULE_NOTE:    (item) => panelManager.openPanel('noteApp', { itemId: item.id }),
            MODULE_AGENDA:  (item) => panelManager.openPanel('agendaPanel', { itemId: item.id, startDate: item.subtitle }),
            MODULE_WEATHER: () => null,
            MODULE_MUSIC:               (item) => panelManager.openPanel('musicPanel', { trackId: item.id }),
            MODULE_MUSIC_PLAYLIST:      (item) => panelManager.openPanel('musicPanel', { playlistId: item.id }),
            MODULE_MUSIC_TRACKS:        (item) => panelManager.openPanel('musicPanel', { trackId: item.id }),
            MODULE_MUSIC_PLAYLISTS:     (item) => panelManager.openPanel('musicPanel', { playlistId: item.id }),
        }
    },

    getQuickActions() {
        return [
            { action: 'openNote', moduleCode: 'NOTE', icon: 'note', keywordsKey: 'keywordsNote' },
            { action: 'openAgenda', moduleCode: 'AGENDA', icon: 'agenda', keywordsKey: 'keywordsAgenda' },
        ]
    },

    getModuleDockMap() {
        return {
            NOTE: { type: 'panel', id: 'noteApp', panelId: 'noteApp', labelKey: 'menu.NOTE', color: '#F59E0B', icon: DOCK_ICONS.noteApp },
            AGENDA: { type: 'panel', id: 'agendaPanel', panelId: 'agendaPanel', labelKey: 'menu.AGENDA', color: '#EF4444', icon: DOCK_ICONS.agendaPanel },
            MUSIC: { type: 'panel', id: 'musicPanel', panelId: 'musicPanel', labelKey: 'menu.MUSIC', color: '#8B5CF6', icon: DOCK_ICONS.musicPanel },
            WEATHER: { type: 'panel', id: 'weatherPanel', panelId: 'weatherPanel', labelKey: 'menu.WEATHER', color: '#38BDF8', icon: DOCK_ICONS.weatherPanel },
        }
    },

    getFileManagerConfig() {
        return {
            entities: true,
            storageQuota: false,
            entityModuleMap: {
                MODULE_NOTE: 'NOTE',
                MODULE_MUSIC: 'MUSIC',
                MODULE_MUSIC_PLAYLIST: 'MUSIC',
            },
            excludeEntities: ['MODULE_VEHICLE_WORK_ORDER'],
        }
    },

    getDockFixedItems() {
        return {
            pages: [
                { id: 'dashboard', route: '/dashboard', labelKey: 'menu.dashboard', color: '#3B82F6', icon: DOCK_ICONS.dashboard },
                { id: 'users', route: '/user', labelKey: 'menu.userList', color: '#10B981', icon: DOCK_ICONS.customers },
                { id: 'companies', route: '/company', labelKey: 'menu.companyList', color: '#F97316', icon: DOCK_ICONS.companies },
                { id: 'products', route: '/ecommerce/product', labelKey: 'menu.productList', color: '#8B5CF6', icon: DOCK_ICONS.product },
                { id: 'modules', route: '/module', labelKey: 'menu.modules', color: '#EC4899', icon: DOCK_ICONS.modules },
            ],
            panels: [
                { id: 'spotlight', panelId: 'spotlight', labelKey: 'common.spotlight.title', color: '#6366F1', icon: DOCK_ICONS.spotlight },
                { id: 'fileManagerPanel', panelId: 'fileManagerPanel', labelKey: 'menu.FILE_MANAGER', color: '#3B82F6', icon: DOCK_ICONS.fileManagerPanel },
            ],
        }
    },
}